import React, {useState} from "react"
import {useForm} from "react-hook-form"
import {Link} from "react-router-dom"
import {Alert, AlertIcon, Button, ButtonGroup, FormControl, FormLabel} from "@chakra-ui/react"

import {IGroup} from "@backend/types"
import {FormInput, FTextArea} from "@components/form"
import {FieldType} from "@components/types"
import UserSelect, {PickedUser} from "@modules/user/components/UserSelect"
import {groupApiCalls} from "@modules/group/service"

type GroupCreateFormProps = {
    group?: IGroup,
    onFinish: () => void
}

const fields: FieldType = {
    title: {
        field: "title",
        label: "Group Title",
        rules: {
            required: "Group title is required"
        }
    },
    description: {
        field: "description",
        label: "Description of Group",
        rules: {
            required: "Group description is required"
        }
    }
}


export default function GroupCreateForm({group, onFinish}: GroupCreateFormProps) {

    const [users, setUsers] = useState<PickedUser[] | null>(group?.userIds as PickedUser[])
    const {
        handleSubmit,
        register,
        formState: {errors, isSubmitting},
    } = useForm({defaultValues: group})

    async function onSubmit(values: IGroup) {
        const {title, description} = values
        const groupData: IGroup = {title, description}

        groupData.userIds = (users || []).map(x => x._id)
        debugger
        if (group?._id) {
            await groupApiCalls.apiCalls.update(group._id, groupData)
        } else
            await groupApiCalls.apiCalls.create(groupData)

        onFinish()
    }

    function onSelectedChange(props: {
        users?: PickedUser[]
    } = {}) {
        setUsers(props.users)
        // clearErrors("input")
        // setSelectedItems({
        //     ...selectedItems,
        //     ...props
        // })
    }

    return <div>
        <form onSubmit={handleSubmit(onSubmit)}>
            <div>
                <div className="grid grid-cols-6 gap-3">
                    <div className="col-span-full">
                        <FormInput register={register} errors={errors} {...fields.title}/>
                    </div>
                    <div className="col-span-full">
                        <FTextArea register={register} errors={errors} {...fields.description}/>
                    </div>
                    <div className="col-span-full">
                        <FormControl>
                            <FormLabel htmlFor="members">Members</FormLabel>
                            <UserSelect
                                users={users}
                                onUsersChange={onSelectedChange}/>
                        </FormControl>
                    </div>
                </div>

                <div className="mt-6 py-6 flex flex-col gap-y-6 border-t">
                    {Object.keys(errors).length > 0 &&
                      <Alert status="error">
                        <AlertIcon/>
                        <ul>
                            {Object.values(errors).map((x, i) =>
                                <li key={i}>{x.message as string}</li>)}
                        </ul>
                      </Alert>}
                    <div className="flex items-center justify-end">
                        <ButtonGroup variant="outline" spacing="6">
                            <Link to="../">
                                <Button>Cancel</Button>
                            </Link>
                            <Button type="submit" isLoading={isSubmitting} colorScheme="blue">Save</Button>
                        </ButtonGroup>
                    </div>

                </div>
            </div>

        </form>
    </div>
}